import React from 'react';
import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';
import { SmoothScroll } from '@components';
import { GlobalStyle } from '@styles';

const variants = {
  initial: {
    opacity: 0,
  },
  enter: {
    opacity: 1,
    transition: {
      duration: 0.5,
      delay: 0.5,
      when: 'beforeChildren',
    },
  },
  exit: {
    opacity: 0,
    transition: { duration: 0.5 },
  },
};

const Layout = ({ children, location }) => {
  const pathname = location?.pathname || '/';

  return (
    <>
      <SmoothScroll callbacks={pathname} />

      <GlobalStyle />
      <AnimatePresence mode="wait">
        <motion.main key={pathname} variants={variants} initial="initial" animate="enter" exit="exit">
          {children}
        </motion.main>
      </AnimatePresence>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

Layout.defaultProps = {
  location: null,
};

export default Layout;
